import { render, staticRenderFns } from "./MemberCard.vue?vue&type=template&id=16e81db8&scoped=true"
import script from "./MemberCard.vue?vue&type=script&lang=js"
export * from "./MemberCard.vue?vue&type=script&lang=js"
import style0 from "./MemberCard.vue?vue&type=style&index=0&id=16e81db8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e81db8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/MAIS/MAIS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16e81db8')) {
      api.createRecord('16e81db8', component.options)
    } else {
      api.reload('16e81db8', component.options)
    }
    module.hot.accept("./MemberCard.vue?vue&type=template&id=16e81db8&scoped=true", function () {
      api.rerender('16e81db8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Member/MemberCard.vue"
export default component.exports